<template>
    <Form class="myForm" ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
        <FormItem label="原密码" prop="oldPwd">
            <Input type="password" v-model="formValidate.oldPwd" autocomplete="off"/>
        </FormItem>
        <FormItem label="新密码" prop="newPwd">
            <Input type="password" v-model="formValidate.newPwd" />
            <p class="tips"><Icon type="md-alert" />请输入8-20位字符，仅含数字、大写字母、小写字母、下划线中的三种或以上</p>
        </FormItem>
        <FormItem label="确认密码" prop="confirmPwd">
            <Input type="password" v-model="formValidate.confirmPwd" />
        </FormItem>
        <FormItem class="align-center">
            <Button type="primary" @click="handleSubmit('formValidate')">保存</Button>
            <Button>取消</Button>
        </FormItem>
    </Form>
</template>

<script>
    import { EncryptCBC, KanqKey, KanqIv } from '@/utils/mycrypto'
    import { isPWD } from '@/utils/validate'
    import {updatePass} from '@/api/manager_user'

    export default {
        name: "updatePwd",
        data(){
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error("请输入密码"));
                } else if(!isPWD(value)) {
                   callback(new Error("请输入8-20位字符，仅含数字、大写字母、小写字母、下划线中的三种或以上"));
                } else {
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error("请输入确认密码"));
                } else if (value !== this.formValidate.newPwd) {
                    callback(new Error("2次密码不一样"));
                } else {
                    callback();
                }
            };
            return{
                formValidate: {
                    username: sessionStorage.getItem('usCode'),
                    oldPwd: '',
                    newPwd: '',                   
                    confirmPwd: ''
                },
                ruleValidate: {
                    oldPwd: [
                        { required: true, message: '请输入原密码', trigger: 'blur' }
                    ],
                    newPwd: [
                        { required: true, message: '请输入新密码', trigger: 'blur' },
                        { validator: validatePass,trigger: 'blur'}
                    ],
                    confirmPwd: [
                        { required: true, message: '请输入确认密码', trigger: 'blur' },
                        { validator: validatePass2,trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            handleSubmit (name) {
                this.$refs[name].validate((valid) => {
                    if (!valid) {
                        return this.$Message.error('请按要求填写密码!');
                    }
                    //密码加密传输
                    const iv = KanqIv();
                    const key = KanqKey();
                    let userpass1 = EncryptCBC(this.formValidate.oldPwd, key, iv);
                    let userpass2 = EncryptCBC(this.formValidate.newPwd, key, iv);

                    this.formValidate.oldPwd = key+ userpass1;
                    this.formValidate.newPwd = key+ userpass2;

                    return new Promise((resolve, reject) => {
                        let params = this.formValidate;
                        updatePass(params).then(response => {
                            const resData = response.data;
                            if (resData.status != 0) {
                                this.removepwd();
                                this.$Message.error(resData.msg);
                            }else{
                                this.removepwd();
                                this.$Message.success(resData.msg);
                            }
                            resolve();
                        }).catch(error => {
                            reject(error);
                            this.removepwd();
                            this.$Message.error('修改失败');
                        });
                    })
                })
            },
            removepwd(){
                this.formValidate.oldPwd ='';
                this.formValidate.newPwd ='';
                this.formValidate.confirmPwd = "";
            }
        }
    }
</script>

<style lang="less" scoped>
    @import url("../../../../static/css/common.less");

    .myForm{
        width: 435px;
        margin: 80px auto 0;
        .tips{
            margin-bottom: -15px;
            color: #C0C4CC;
            .ivu-icon{
                margin-right: 10px;
            }
        }
        .align-center{
            text-align: center;
        }
        /deep/ .ivu-form-item{
            margin-bottom: 30px;
        }
        /deep/ .ivu-form-item-label{
            padding: 12px 12px 12px 0;
            font-size: 16px;
        }
        /deep/ .ivu-input{
            height: 40px;
        }
        /deep/ .ivu-btn{
            height: 40px;
            margin-top: 100px;
            margin-right: 50px;
        }
        /deep/ .ivu-form-item-error-tip{
            top: 90%;
        }
    }
</style>
